
export const SPOT_REMOTE_P2P_ACTIVE = 'spotRemoteP2PActive';
